import React from "react";
import RestView from "./RestView";
import { UseRestProps } from "./type";
import { useRest } from "./useRest";

function Interphone() {
  const hook: UseRestProps = useRest();

  return <RestView hook={hook} />;
}
export default React.memo(Interphone);
